import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { CHART_INK } from './agencyChartTheme';

const useStyles = createUseStyles({
    body: {
        fontSize: 12.5,
        lineHeight: 1.5,
        color: CHART_INK.label
    }
});

export const HistoryWaitNote: FC<{
    /** Which panel this speaks for, so a driver can select one without counting from the top. */
    panel: string;
    children: string;
}> = ({ panel, children }) => {
    const classes = useStyles();

    return <div className={classes.body} data-id={`insights-pending-${panel}`}>{children}</div>;
};
